<template>
  <el-dialog :title="formData.id ? $t('common.edit') : $t('common.add')" :visible.sync="dialogVisible" width="800px" @close="handleClose" :destroy-on-close="true">
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item :label="$t('plugin.activityForm.sort')" prop="sort">
        <el-input class="input-w" type="text" v-model.number="formData.sort" autocomplete="off" :placeholder="$t('plugin.activityForm.sortPh')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('plugin.activity.name')" prop="name">
        <el-input class="input-w" v-model="formData.name" autocomplete="off" :placeholder="$t('plugin.activityForm.namePh')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('plugin.activityForm.enrollTime')" prop="enrollEndAt">
        <el-date-picker v-model="timeDataList" type="datetimerange" value-format="timestamp" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" @change="changTime"></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('plugin.activityForm.activityType')" prop="type">
        <el-select class="input-w" v-model="formData.type" :placeholder="$t('common.pleaseSelect')">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="formData.type != 1">
        <el-form-item :label="$t('plugin.activityForm.completeOrders')" prop="condition">
          <el-input class="input-w" v-model.number="formData.condition" autocomplete="off" :placeholder="$t('plugin.activityForm.completeOrdersPh')">
            <template slot="append">{{ $t('common.order') }}</template>
          </el-input>
        </el-form-item>
      </template>
      <el-form-item :label="$t('plugin.activityForm.completeReward')" prop="reward">
        <el-input class="input-w" v-model.number="formData.reward" autocomplete="off" :placeholder="$t('plugin.activityForm.completeRewardPh')">
          <template slot="append">{{ $t('common.yuan') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('plugin.activityForm.activityDate')" prop="activityEndAt">
        <el-date-picker v-model="timeDataList1" type="daterange" value-format="timestamp" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" @change="changTimeTwo"></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('plugin.activityForm.activityTime')" prop="timeArr">
        <template v-for="(item,index) of formData.timeArr">
          <div class="timeList flex-bet" style="width: 300px; margin-bottom: 10px;" :key="index">
            <el-time-select style="width: 140px;" :placeholder="$t('plugin.activityForm.startTimePh')" v-model="item.startAt" :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:59'
            }"></el-time-select>
            <el-time-select style="width: 140px;" :placeholder="$t('plugin.activityForm.endTimePh')" v-model="item.endAt" :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:59',
            minTime: item.startAt
            }"></el-time-select>
            <i class="icon el-icon-circle-close" @click="delTime(index)"></i>
          </div>
        </template>
        <el-button type="text" v-if="formData.timeArr.length < 3" @click="addtime">+{{ $t('plugin.activityForm.addTimeSlot') }}</el-button>
      </el-form-item>
      <el-form-item :label="$t('plugin.activityForm.activityDesc')" prop="body">
        <baidu-ueditor :content="formData.body" @ueditor="getUeditor"></baidu-ueditor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addActive, getActiveInfo } from '@/api/plugins';
import baiduUeditor from '../../../plugins/baidu-ueditor.vue';
export default {
  components: { baiduUeditor },
  data() {
    return {
      dialogVisible: false,
      formData: {
        sort: '',
        name: '',
        enrollStartAt: '',
        enrollEndAt: '',
        type: '',
        condition: '',
        reward: '',
        activityStartAt: '',
        activityEndAt: '',
        timeArr: [],
        body: '',
        id: ''
      },
      timeDataList: [],
      timeDataList1: []
    };
  },
  computed: {
    rules() {
      return {
        sort: [
          { required: true, message: this.$t('plugin.activityForm.sortRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('plugin.activityForm.sortNumber'), trigger: ['blur', 'change'] }
        ],
        name: [{ required: true, message: this.$t('plugin.activityForm.nameRequired'), trigger: 'blur' }],
        enrollEndAt: [{ required: true, message: this.$t('plugin.activityForm.enrollTimeRequired'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('plugin.activityForm.typeRequired'), trigger: 'blur' }],
        condition: [
          { required: true, message: this.$t('plugin.activityForm.conditionRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('plugin.activityForm.conditionNumber'), trigger: ['blur', 'change'] }
        ],
        reward: [
          { required: true, message: this.$t('plugin.activityForm.rewardRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('plugin.activityForm.rewardNumber'), trigger: ['blur', 'change'] }
        ],
        activityEndAt: [{ required: true, message: this.$t('plugin.activityForm.activityTimeRequired'), trigger: 'blur' }]
      };
    },
    typeOptions() {
      return [
        { value: 1, label: this.$t('plugin.activity.firstOrderReward') },
        { value: 2, label: this.$t('plugin.activity.rushReward') }
      ];
    }
  },
  methods: {
    changTime(msg) {
      this.formData.enrollStartAt = msg[0] / 1000;
      this.formData.enrollEndAt = msg[1] / 1000;
    },
    changTimeTwo(msg) {
      this.formData.activityStartAt = msg[0] / 1000;
      this.formData.activityEndAt = msg[1] / 1000;
    },
    init(id) {
      this.dialogVisible = true;
      if (id) {
        getActiveInfo({ id }).then((res) => {
          if (res.code == 1) {
            res.data.reward = parseFloat(res.data.reward);
            Object.assign(this.formData, res.data);
            this.timeDataList = [this.formData.enrollStartAt * 1000, this.formData.enrollEndAt * 1000];
            this.timeDataList1 = [this.formData.activityStartAt * 1000, this.formData.activityEndAt * 1000];
          }
        });
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          addActive(this.formData).then((res) => {
            if (res.code == 1) {
              this.$baseMessage(res.msg, 'success');
              this.handleClose();
            }
          });
        }
      });
    },
    getUeditor(msg) {
      this.formData.body = msg;
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('callback', false);
    },
    addtime() {
      if (this.formData.timeArr.length > 0) {
        const data = this.formData.timeArr[this.formData.timeArr.length - 1];
        if (data.startAt && data.endAt) {
          this.formData.timeArr.push({ startAt: '', endAt: '' });
        } else {
          this.$baseMessage(this.$t('plugin.activityForm.timeSlotIncomplete'), 'warning');
        }
      } else {
        this.formData.timeArr.push({ startAt: '', endAt: '' });
      }
    },
    delTime(index) {
      this.formData.timeArr.splice(index, 1);
    }
  }
};
</script>

<style lang="stylus" scoped>
.timeList {
  position: relative;

  .icon {
    position: absolute;
    font-size: 20px;
    right: -24px;
    top: 50%;
    transform: translateY(-50%);
    color: #DCDFE6;
  }

  .icon:hover {
    color: #ff0000;
  }
}
</style>
